import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import VueConfigManager from 'vue-config-manager'
import { sync } from 'vuex-router-sync' // handily adds router state to store state if you're into that kind of thing ( READ ONLY )
import VueAnalytics from 'vue-analytics'

import App from './App.vue'
import store from './store'
import router from './router'
import config from './config/global'

Vue.config.productionTip = false
Vue.use(VueConfigManager, ...config)
Vue.use(VueAnalytics, {
  id: 'UA-101754345-1'
})

// eslint-disable-next-line
const unsync = sync(store, router)
// unsync() function. Unsyncs store from router

/* eslint-disable no-new */
new Vue({
  methods: {
    ...mapActions([
      'getContentTypes',
      'getEntries',
      'getEntry',
      'getAsset',
      'getLinkedEntries',
      'updateAppRootData',
      'updateAppData',
      'updatePages',
      'getContentType'
    ])
  },
  computed: {
    ...mapGetters([
      'domain'
    ])
  },
  created: function () {
    let vue = this
    // console.log('Created Vue root', vue)
    // console.log('Getting domain data')

    // Get the domain root data, then get the root website data associated with that domain, and in turn all page data (and links) for the website
    vue.getEntry(vue.domain)
      .then((d) => {
        // console.log(d)
        // specific, not very pretty, getting the domain logo and logo alt
        vue.getAsset(d.fields.logo.sys.id).then(function (asset) {
          Vue.set(d.fields.logo, 'file', asset.fields.file)
          vue.updateAppRootData(d)
        })
        vue.getAsset(d.fields.logoAlt.sys.id).then(function (asset) {
          Vue.set(d.fields.logoAlt, 'file', asset.fields.file)
          vue.updateAppRootData(d)
        })
        vue.updateAppRootData(d)
        return d
      })
      .then((d) => {
        vue.getLinkedEntries({id: d.fields.website.sys.id, update: 'app'})
        vue.updateAppRootData(d)

        vue.getContentType({contentType: 'product', type: 'Courses'}) // type is case sensitive...
      })
  },
  sockets: {},
  router,
  store,
  components: { App },
  template: '<App />'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js